import { query } from './query';
import { isDefined, isObject } from './types';

/** @param {object} object */
export function isObjectEmpty(object) {
  for (let prop in object) {
    if (Object.hasOwnProperty.call(object, prop)) {
      return false;
    }
  }
  return true;
}

/**
 * @template T
 * @param {T[]} arr
 * @returns {T[]}
 */
export function removeEmptyElementsFromTheArrayRight(arr) {
  const newArr = arr.slice();

  while (newArr.length > 0) {
    const lastElement = newArr[newArr.length - 1];

    if (lastElement === '' || (isObject(lastElement) && isObjectEmpty(lastElement))) {
      newArr.pop();
    } else {
      return newArr;
    }
  }

  return newArr;
}

/** @returns {number} */
export function getCurrentTimestampInSeconds() {
  return Math.floor(new Date().getTime() / 1000);
}

/**
 * @param {HTMLElement} sourceElement
 * @returns {HTMLElement}
 */
export function getSourceElement(sourceElement) {
  let parentElement;

  parentElement = sourceElement.parentNode;
  while (
    parentElement !== null &&
    /* buggy IE5.5 */
    isDefined(parentElement)
  ) {
    if (query.isLinkElement(sourceElement)) {
      break;
    }
    sourceElement = /** @type {HTMLElement} */ (parentElement);
    parentElement = sourceElement.parentNode;
  }

  return sourceElement;
}

/**
 * @param {Date} [date]
 * @returns {number}
 */
export function getUnixTimestamp(date) {
  return Math.round((date || new Date()).getTime() / 1000);
}
